import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { getText, getRedirectUrl, trackGA } from 'misc/helpers';
import MyForm from '../shared/form/MyForm';
import InputField from '../shared/form/InputField';
import { required, email } from 'misc/validations';
import * as types from 'misc/types';

class Verify extends Component {
    constructor(props) {
        super(props);

        const { customer } = this.props;

        // Save redirect url
        let redirectUrl = getRedirectUrl();
        if (!redirectUrl) {
            redirectUrl = '/inbox';
        }

        let verifyData = JSON.parse(JSON.stringify(customer.data));
        verifyData.email = verifyData.pendingEmail;
        verifyData.redirectUrl = redirectUrl;

        this.state = {
            verifyData: verifyData,
            redirectUrl: redirectUrl,
        };
    }

    render = () => {
        return (
            <div className="main-content">
                <div className="complement-content">
                    <img className="complement-logo verify-logo" src="assets/images/verify/ico_dm_v.svg" alt="" />
                    <h1>{getText('_6_1_Titel_verifyemail', 'Verifiera din E-post')}</h1>
                    <p>
                        {getText(
                            '_6_1_textverifyemail',
                            'Vi ser att du inte har verifierat din e-postadress. Vi har skickat ett mail till dig där vi vill att du verifierar e-postadressen. Om du har tappat bort brevet, vänligen klicka på skicka igen. Om det blivit något fel på e-postadressen kan du ange det på nytt nedan.'
                        )}
                    </p>

                    <MyForm
                        name="VerifyForm"
                        sagaAction={types.SAGA_CUSTOMER_PUT}
                        initialValues={this.state.verifyData}
                        buttonClasses="button-yellow button-big"
                        submitLabel={getText('_6_1_buttonsend', 'Skicka igen')}
                    >
                        <InputField
                            name="email"
                            type="text"
                            validate={[required, email]}
                            placeholder={getText('ProfileEmail', 'E-postadress')}
                            icon="assets/images/settings/ico_email.svg"
                        />
                    </MyForm>
                    <Link to={this.state.redirectUrl}>{getText('_6_1_buttonskip', 'Hoppa över')}</Link>
                </div>
                <img className="logo-bottom-left" src="assets/images/digimail_logo_yellow.svg" alt="" />
            </div>
        );
    };

    componentDidMount() {
        trackGA('6.1 Verifiera epost');
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        customer: state.customer
    };
};

export default connect(mapStateToProps)(Verify);



// WEBPACK FOOTER //
// ./src/components/views/Verify.js